var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMicrosoftAuthenticator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7528 6.24732C13.7528 6.30592 13.7528 6.36062 13.7489 6.41923C13.2963 6.32155 12.8241 6.24341 12.3363 6.1809C12.3012 4.91893 11.271 3.90702 10.0027 3.90702C8.73445 3.90702 7.70033 4.91893 7.66911 6.1809C7.18132 6.24341 6.70914 6.32155 6.25647 6.41923C6.25257 6.36062 6.25257 6.30201 6.25257 6.24341C6.25257 4.16879 7.93057 2.48486 10.0066 2.48486C12.0709 2.49268 13.7528 4.17269 13.7528 6.24732ZM10.0183 17.5151C16.6445 14.7255 15.6338 7.62259 15.6338 7.62259C14.0884 7.04435 12.1373 6.70053 10.0105 6.70053C7.88374 6.70053 5.93258 7.04435 4.38726 7.62259C4.38726 7.62259 3.37655 14.7255 10.0027 17.5151H10.0183Z",
    fill: "#3D3C42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.844 13.0416C11.844 13.1236 11.8401 13.2018 11.8284 13.2799H8.18748C8.17578 13.2018 8.17188 13.1236 8.17188 13.0416C8.17188 12.2133 8.7182 11.5139 9.47135 11.2834C8.96405 11.0724 8.60503 10.5723 8.60503 9.9863C8.60503 9.2088 9.23331 8.58368 10.006 8.58368C10.7786 8.58368 11.4069 9.21271 11.4069 9.9863C11.4069 10.5723 11.0479 11.0724 10.5406 11.2834C11.2976 11.51 11.844 12.2133 11.844 13.0416Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMicrosoftAuthenticator);
export default __webpack_public_path__ + "static/media/ic_microsoft_authenticator.994aa8171d69990cbcede188c284a7c6.svg";
export { ForwardRef as ReactComponent };